class DeliveryCollectBlock extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-tab]')
    this.panels = this.querySelectorAll('[data-panel]')
    this.collectForm = this.querySelector('[data-form="collect"]')
    this.collectResults = this.querySelector('[data-cc-results]')
    this.sectionId = this.dataset.sectionId

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.switchTab(tab.dataset.tab))
    })

    // Click & Collect: postcode doesn't filter results (only 2 fixed
    // locations) — submitting just reveals the already-rendered
    // availability for the current variant.
    if (this.collectForm) {
      this.collectForm.addEventListener('submit', (event) => {
        event.preventDefault()
        if (this.collectResults) {
          this.collectResults.hidden = false
        }
      })
    }

    // Re-render this block when the shopper picks a different variant,
    // so pickup/preorder status matches the newly selected variant.
    document.addEventListener('variant:changed', (event) => this.onVariantChanged(event))
  }

  switchTab(target) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === target
      tab.classList.toggle('is-active', isActive)
      tab.setAttribute('aria-selected', isActive)
    })

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === target
      panel.classList.toggle('is-active', isActive)
      panel.hidden = !isActive
    })
  }

  async onVariantChanged(event) {
    const variantId = event.detail?.variant?.id
    if (!variantId || !this.sectionId) return

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`

    try {
      const response = await fetch(url)
      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const fresh = doc.querySelector('delivery-collect-block')

      if (fresh) {
        // preserve which tab was open before swapping markup
        const activeTab = this.querySelector('[data-tab].is-active')?.dataset.tab || 'delivery'
        this.replaceWith(fresh)
        fresh.connectedCallback?.() // safety if not auto-upgraded yet
        fresh.switchTab?.(activeTab)
      }
    } catch (err) {
      console.error('Delivery/Collect: failed to refresh availability', err)
    }
  }
}

if (!customElements.get('delivery-collect-block')) {
  customElements.define('delivery-collect-block', DeliveryCollectBlock)
}